import type {CsrfResponse} from "@project/sdk/security";

import {getBeginBffLoginUrl, getSubmitBffLogoutUrl} from "@project/sdk/security";

export function getLoginUrl(returnTo: string) {
  const safeReturnTo = toRootRelativeReturnTo(returnTo);

  return getBeginBffLoginUrl({returnTo: safeReturnTo});
}

function toRootRelativeReturnTo(returnTo: string) {
  if (returnTo.startsWith("/") && !returnTo.startsWith("//")) return returnTo;

  try {
    const url = new URL(returnTo);

    if (url.origin === globalThis.location?.origin) {
      return `${url.pathname}${url.search}${url.hash}`;
    }
  } catch {
    return "/";
  }

  return "/";
}

export function getLogoutUrl() {
  return getSubmitBffLogoutUrl();
}

export function getLogoutFormConfig(
  csrf: Pick<CsrfResponse, "parameterName"> | undefined,
  token: string | null,
) {
  if (!csrf || !token) return null;

  return {
    action: getLogoutUrl(),
    method: "POST" as const,
    parameterName: csrf.parameterName,
    token,
  };
}
